import React from 'react';
import { Row, Col } from 'reactstrap'
import Viz from 'components/Tableau/Viz';

const TableauDashboard = (props) => {

  return (
    <>
      <Row>
        <Col>
          <Viz url='https://tableau.deacero.com/views/ProduccionPB_17435407082900/Production/4aa704ae-36fd-4532-aec7-b792cecbd556/3dede8a3-09fb-4cee-8266-ca60feeea16e' />
        </Col>
      </Row>
    </>
    
  )

}

export default TableauDashboard;